/* eslint-disable jsx-a11y/anchor-is-valid */
import {KTableProvider} from '../../../../../../contexts/KTableProvider'
import {TableOption} from './columns'

const TableOptionWrapper = () => {
  return (
    <KTableProvider>
      <TableOption />
    </KTableProvider>
  )
}

export {TableOptionWrapper}
